import React from 'react';
const SvgIdwThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
      <defs>
        <linearGradient x1="0%" y1="48.76%" x2="100%" y2="48.76%" id="idw-thumbnail_svg__b">
          <stop stopColor="#E82" offset="0%" />
          <stop stopColor="#F9CD8C" offset="98%" />
          <stop stopColor="#F9CD8C" offset="100%" />
        </linearGradient>
        <linearGradient x1=".88%" y1="49.133%" x2="100.88%" y2="49.133%" id="idw-thumbnail_svg__c">
          <stop stopColor="#B06E2F" offset="0%" />
          <stop stopColor="#714107" offset="84%" />
          <stop stopColor="#714107" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="49.693%" x2="165.834%" y2="49.693%" id="idw-thumbnail_svg__d">
          <stop stopColor="#ED8722" offset="0%" />
          <stop stopColor="#E88422" offset="16%" />
          <stop stopColor="#DA7C21" offset="34%" />
          <stop stopColor="#C26F1F" offset="54%" />
          <stop stopColor="#A15D1D" offset="75%" />
          <stop stopColor="#77461A" offset="97%" />
          <stop stopColor="#70421A" offset="100%" />
        </linearGradient>
        <linearGradient x1="55.786%" y1="47.351%" x2="47.399%" y2="-9.869%" id="idw-thumbnail_svg__e">
          <stop stopColor="#A75726" offset="0%" />
          <stop stopColor="#A75726" offset="8%" />
          <stop stopColor="#B36128" offset="22%" />
          <stop stopColor="#D27B2E" offset="62%" />
          <stop stopColor="#DE8530" offset="84%" />
          <stop stopColor="#DE8530" offset="100%" />
        </linearGradient>
        <linearGradient x1="65.632%" y1="-13.563%" x2="34.792%" y2="111.522%" id="idw-thumbnail_svg__f">
          <stop stopColor="#E82" offset="0%" />
          <stop stopColor="#F8CBA9" offset="12%" />
          <stop stopColor="#F6C397" offset="17%" />
          <stop stopColor="#F1B575" offset="26%" />
          <stop stopColor="#EEAB5C" offset="35%" />
          <stop stopColor="#ECA54D" offset="44%" />
          <stop stopColor="#EBA348" offset="50%" />
          <stop stopColor="#733C0F" offset="100%" />
        </linearGradient>
        <radialGradient
          cx="79.786%"
          cy="166.939%"
          fx="79.786%"
          fy="166.939%"
          r="331.102%"
          gradientTransform="matrix(.28727 0 0 1 .569 0)"
          id="idw-thumbnail_svg__a"
        >
          <stop stopColor="#6A4745" offset="0%" />
          <stop stopColor="#ED8722" offset="95%" />
          <stop stopColor="#ED8722" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#DE8530" d="M69 3l20 20H69z" />
        <path fill="#EEAD60" d="M11 3v94h78V23H69V3z" />
        <path fill="#FFF" d="M15 8h54v15h16v50H15z" />
        <path
          d="M.113 44.756V45c3.94-.61 7.919-.942 11.906-.994 3.513.074 7.016.407 10.481.994-.262-.15-2.719-6.431-9.637-6.431L.113 44.756z"
          fill="url(#idw-thumbnail_svg__a)"
          fillRule="nonzero"
          transform="translate(38 18)"
        />
        <path
          d="M16.163 38.569c1.012.093 5.943 0 6.43 0l-1.65-1.275h-2.362c-.787 0-2.025-1.219-2.418-1.875a3.938 3.938 0 010 3.15z"
          fill="url(#idw-thumbnail_svg__b)"
          transform="translate(38 18)"
        />
        <path
          d="M16.163 11.25a2.362 2.362 0 012.418-2.269h1.463l2.456-2.55a4.406 4.406 0 00-6.394 0l.056 4.819z"
          fill="url(#idw-thumbnail_svg__c)"
          fillRule="nonzero"
          transform="translate(38 18)"
        />
        <path
          d="M1.481 37.369l-1.387 1.2c7.631 1.875 10.875-8.25 6.431-3.207a7.313 7.313 0 01-5.044 2.007z"
          fill="url(#idw-thumbnail_svg__d)"
          transform="translate(38 18)"
        />
        <path
          d="M22.5 0s-7.238.938-11.25.938C7.237.938 0 0 0 0v6.431C.563 6.412 3.094 7.5 3.75 7.5c6.469 0 12.3 30.881 12.375 31.069V11.212c0-2.568.825-4.593 3.244-4.856a31.313 31.313 0 013.187 0L22.5 0z"
          fill="url(#idw-thumbnail_svg__e)"
          transform="translate(38 18)"
        />
        <path
          d="M19.331 38.569C12.92 38.569 12.825 6.694 3.3 6.43H.094l1.875 2.682h2.1a2.625 2.625 0 012.437 2.23s.281 11.794 0 19.294a46.875 46.875 0 01-.637 5.925c-.9 1.988-3.113 2.12-5.775 1.988V45a21.994 21.994 0 0111.719-3.075c3.8-.155 7.55.923 10.687 3.075v-6.431h-3.169z"
          fill="url(#idw-thumbnail_svg__f)"
          transform="translate(38 18)"
        />
        <path fill="#92571E" opacity={0.2} d="M69 23h20v20z" />
        <path
          d="M30 77h2.09v15.708H30V77zm7.7 13.948h3.476c.235 0 .528-.018.88-.055a5.128 5.128 0 002.299-.869 3.97 3.97 0 001.045-1.078c.308-.455.561-1.023.759-1.705.198-.682.297-1.507.297-2.475 0-.939-.092-1.778-.275-2.519-.183-.74-.484-1.371-.902-1.892a3.962 3.962 0 00-1.617-1.188c-.66-.271-1.474-.407-2.442-.407H37.7v12.188zM35.61 77H41c2.42 0 4.283.616 5.588 1.848 1.305 1.232 1.958 3.11 1.958 5.632 0 1.32-.147 2.49-.44 3.509-.293 1.02-.748 1.877-1.364 2.574-.616.697-1.4 1.228-2.354 1.595-.953.367-2.083.55-3.388.55h-5.39V77zm29.678 15.708H63.11l-3.586-13.2h-.044l-3.63 13.2h-2.178L49.646 77h2.134l3.08 13.068h.044L58.424 77h2.266l3.476 13.068h.044L67.4 77h2.09l-4.202 15.708z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
});
export default SvgIdwThumbnail;
SvgIdwThumbnail.iconName = 'idw-thumbnail';
SvgIdwThumbnail.displayName = 'SvgIdwThumbnail';
